// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"config__termsAndConditions___hCvrW"};